var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingCardIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37803"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37804",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 140581",
    fill: "none",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 20.5,
    height: 20.5,
    rx: 3.25
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.266 9.31a1.252 1.252 0 0 0-.992-.853l-3.581-.582-1.662-3.225a1.257 1.257 0 0 0-2.236 0L8.136 7.876l-3.581.581a1.257 1.257 0 0 0-.691 2.126l2.555 2.574-.553 3.585a1.257 1.257 0 0 0 1.808 1.315l3.24-1.633 3.239 1.633a1.257 1.257 0 0 0 1.809-1.314l-.554-3.586 2.555-2.575a1.252 1.252 0 0 0 .3-1.274Zm-1 .578-2.906 2.93.629 4.078a.268.268 0 0 1-.387.281l-3.688-1.86-3.684 1.859a.268.268 0 0 1-.387-.281l.631-4.078-2.908-2.929a.269.269 0 0 1 .148-.454l4.073-.662 1.887-3.67a.268.268 0 0 1 .478 0l1.888 3.669 4.073.662a.269.269 0 0 1 .148.454Z",
    fill: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingCardIconWhite);
export default __webpack_public_path__ + "static/media/Rating_Card_icon-white.7774ba12b6d192776ff7bedd870c9258.svg";
export { ForwardRef as ReactComponent };